if (!customElements.get('collection-tabs')) {
  /**
   *  @class
   *  @function CollectionTabs
   */
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.container = this.closest('.collection-tabs')
      if (!this.container) return
      this.initGrid()
      setTimeout(() => {
        this.target = this.dataset.target
        const buttons = Array.from(this.querySelectorAll('button'))
        this.addEventListener('click', event => {
          if (event.target.tagName === 'BUTTON') {
            event.preventDefault()
            const button = event.target
            this.activeHandle = button.dataset.collection
            const url = button.dataset.url
            ;[].forEach.call(buttons, function (el) {
              el.classList.remove('active')
            })

            button.classList.add('active')
            this.scrollTo({
              left: (button.offsetLeft + button.clientWidth / 2) - document.body.clientWidth / 2 + 34,
              behavior: "smooth"
            });

            if (this.activeHandle) {
              this.toggleCollection(this.activeHandle, url)
              this.collapseGridItems()
            }
          }
        })
        this.querySelector('button.active').dispatchEvent(new Event('click', { bubbles: true }))
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', event => {
            const index = buttons.indexOf(event.target)
  
            buttons[index].dispatchEvent(new Event('click', { bubbles: true }))
          })
          this.addEventListener('shopify:section:load', () => {
            this.initGrid()
          })
        }
      }, 20)
    }
    initGrid() {
      this.activeHandle = this.activeHandle || this.querySelector('button.active')?.dataset.collection
      this.collapsed = true
      if (this.container.querySelector(this.getGridItemSelector())) {
        const container = this.container
        const REG = '(\\w+)-(\\d+)\\/?(\\d+)?'
        const showBtn = container.querySelector('.collection-tabs--button')
        const classes = container.querySelector(this.getGridItemSelector()).getAttribute('class').match(new RegExp(REG, 'g'))
        const bps = classes.map(str => {
          const matches = str.match(new RegExp(REG))
          const name = matches[1]
          const index = matches[2]
          const denominator = matches[3]
          const cols = denominator ? Math.floor(1 / (index / denominator)) : (12 / parseInt(index))
          return { name, cols }
        })
        this.collapseGridItems = () => {
          const order = ['large', 'medium']
          const ems = { large: 66.75, medium: 48 } // 对应 breakpoint 的 em 值
          // mobile show 4 items, 2 cols per row
          const cols = (bps.find(v => v.name === order.find(o => window.matchMedia(`print, screen and (min-width: ${ems[o]}em)`).matches)) || {}).cols || 2
          if (showBtn) {
            if (cols * 2 >= container.querySelectorAll(this.getGridItemSelector()).length) {
              showBtn.classList.add('is-hidden') // 此时不需要显示 Show More
            } else {
              showBtn.classList.remove('is-hidden')
            }
          }
          ;[].forEach.call(container.querySelectorAll(this.getGridItemNotSelector()), (el) => {
            el.classList.add('is-hidden')
          })
          ;[].forEach.call(container.querySelectorAll(this.getGridItemSelector()), (el, index) => {
            if (!this.collapsed || index < cols * 2) {
              el.classList.remove('is-hidden')
            } else {
              el.classList.add('is-hidden')
            }
          })
        }
        container.querySelector('.collection-tabs--button')?.addEventListener('click', (evt) => {
          const el = evt.currentTarget
          const button = el.querySelector('.button-title')
          if (this.collapsed) {
            this.collapsed = false
            button.innerText = el.getAttribute('data-view-less')
            button.title = el.getAttribute('data-view-less')
            ;[].forEach.call(container.querySelectorAll(this.getGridItemNotSelector()), el => el.classList.add('is-hidden'))
            ;[].forEach.call(container.querySelectorAll(this.getGridItemSelector()), el => el.classList.remove('is-hidden'))
          } else {
            this.collapsed = true
            button.innerText = el.getAttribute('data-view-more')
            button.title = el.getAttribute('data-view-more')
            this.scrollTo({
              behavior: "smooth"
            });
            this.collapseGridItems()
          }
        })
        this.collapseGridItems()
        window.addEventListener('resize', () => this.collapseGridItems())
      }
    }
    // placeholder
    collapseGridItems = () => {}
    getGridItemSelector() {
      return `.display-type--grid > .columns[data-collection="${this.activeHandle}"]`
    }
    getGridItemNotSelector() {
      return `.display-type--grid > .columns:not([data-collection="${this.activeHandle}"])`
    }
    toggleCollection(handle,url) {
      const slider = document.getElementById(this.target),
        products = slider.querySelectorAll(`.columns:not([data-collection="${handle}"])`),
        active_products = slider.querySelectorAll(`[data-collection="${handle}"]`),
        btn = slider.closest('.collection-tabs').querySelector(".collection_btn"),
        collectionContents = slider.closest('.collection-tabs').querySelectorAll(`.collection-text-content`),
        flkty = Flickity.data(slider),
        tabs = slider.closest('.collection-tabs').querySelectorAll(`.collection-tab:not([data-tab="${handle}"])`),
        active_tabs = slider.closest('.collection-tabs').querySelectorAll(`[data-tab="${handle}"]`)
      if(btn && url){
        btn.setAttribute("href",url)
      }
      ;[].forEach.call(collectionContents, function (el) {
        el.classList.add('hidden')
        if (el.dataset.handle === handle) {
          el.classList.remove('hidden')
        }
      });
      ;[].forEach.call(tabs, function (el) {
        el.classList.remove('active')
      })
      ;[].forEach.call(active_tabs, function (el) {
        el.classList.add('active')
      })
      ;[].forEach.call(products, function (el) {
        el.classList.remove('carousel__slide')
        el.classList.add('is-hidden')
        slider.append(el)
      })
      ;[].forEach.call(active_products, function (el) {
        el.classList.add('carousel__slide')
        if (flkty) {
          el.classList.remove('is-hidden')
        }
      })
      if (flkty) {
        flkty.insert(active_products)
        flkty.reloadCells()
        flkty.select(0, 0, 1)
        setTimeout(() => {
          requestAnimationFrame(() => {
            flkty.resize(2)
          })
        });
      }

      if (slider.classList.contains('same-height')) {
        slider.querySelectorAll('.carousel__slide').forEach(item => {
          item.style.top = 0
          item.style.bottom = 0
        })
      }
    }
  }
  customElements.define('collection-tabs', CollectionTabs)
}
